<template>
  <div v-b-tooltip.hover.left="'Gerenciador de tarefas'"
       :class="{'atalho-gerenciador-selecionado': propClickedOnConexaoComWs, 'atalho-gerenciador': !propClickedOnConexaoComWs}"
       @click="closeSideBar">
    <div v-if="$store.state.webSockets.info.qtdTarefasPendentes"
         id="amountOfTasks"
         :class="{'qtdTarefasContainerSelecionado': propClickedOnConexaoComWs, 'qtdTarefasContainer': !propClickedOnConexaoComWs}">
      <span class="qtdTarefas">
        {{ $store.state.webSockets.info.qtdTarefasPendentes > 99 ? '99+' : $store.state.webSockets.info.qtdTarefasPendentes }}
      </span>
      <IconSvg id="iconManager"
               class="icon--md"
               icon="clipboard" />
    </div>
  </div>
</template>

<script>
  // Websockect
  import websocket from '@adonisjs/websocket-client'
  import { ws as wsService } from '@/services/api'

  let ws = null
  let gerenciadorTarefas = null

  export default {
    name: 'ConexaoComWs',
    props: {
      propCloseSideBar: { type: Function, default: null },
      propTitlePassedToConexaoComWs: { type: String, default: null },
      propClickedOnConexaoComWs: { type: Boolean, default: false }
    },
    data () {
      return {
      }
    },
    mounted () {
      this.connectToWS()
    },
    methods: {
      connectToWS () {
        ws = websocket(wsService.defaults.baseURL).connect()

        ws.on('open', () => {
          gerenciadorTarefas = ws.getSubscription('gerenciadorTarefas')

          if (!gerenciadorTarefas) {
            this.subscribeWSChannel()
          }
        })
      },
      subscribeWSChannel () {
        gerenciadorTarefas = ws.subscribe('gerenciadorTarefas')

        gerenciadorTarefas.on('ready', () => gerenciadorTarefas.emit('message', this.$store.state.auth.cartorio_id))

        gerenciadorTarefas.on('error', (error) => error)

        gerenciadorTarefas.on('message', (message) => this.$store.dispatch('webSockets/updateInfo', message))
      },
      closeSideBar () {
        this.$router.push('/gerenciador')
        this.propTitlePassedToConexaoComWs && setTimeout(async () => await this.propCloseSideBar('CloseReleaseNotesTabByConexaoComWs'), 300)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .atalho-gerenciador-base {
    border: none;
    cursor: pointer;
    margin: auto;
    width: fit-content;
  }
  
  .atalho-gerenciador {
    @extend .atalho-gerenciador-base;
  }

  .atalho-gerenciador-selecionado {
    @extend .atalho-gerenciador-base;

    background-color: #0A6CAE;
    fill: #fff;
  }

  .qtdTarefasBase {
    position: absolute;
    top: -1vh;
    right: 0;
    width: 1.1rem;
    height: 1.1rem;
    font-weight: 500;
    font-size: .7rem;
    border-radius: 100%;  
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .qtdTarefasContainer {
    position: relative;

    .qtdTarefas {
      @extend .qtdTarefasBase;
      background: #8b0000;
      color: white;
    }
  }

  .qtdTarefasContainerSelecionado {
    position: relative;

    .qtdTarefas {
      @extend .qtdTarefasBase;
      background: white;
      border:1px solid #0A6CAE;
      color: #0A6CAE;
    }
  }
</style>
